/**
 * 레퍼런스(api):https://github.kakaocorp.com/kakaopage/api/blob/c7b2307cf7f9761b8db7501e31c75d383a2f43a4/common/src/main/java/com/kakaopage/common/model/boxing/DRMType.java#L15
 */
export enum DrmTypeVo {
  None = 'NONE',
  Widevine = 'WIDEVINE',
  PlayReady = 'PLAYREADY',
  Fairplay = 'FAIRPLAY',
}
